import { useCallback } from 'react';
import { DateSelect, Filter } from '@namespace/common';
import { stringifySearchParams } from '@namespace/helpers';
import { useI18n, useLocation } from '@namespace/i18n';
import { useHistory } from '@namespace/router';
import {
  ALL_FILTER_TYPE,
  CATEGORIES_FILTER,
  DATE_FILTER,
  STATUS_FILTER
} from '../../../../constants';
import {
  notificationCenterActions,
  useNotificationCenterStore
} from '../../../../store';
import { prepareFilterForRequest } from '../../../../utils/prepareFilterForRequest';

import styles from './index.module.css';

const { FETCH_MESSAGES_LIST_DATA } = notificationCenterActions;

export const Filters = ({ currentFilter, classNames }) => {
  const messagesListPaginationData = useNotificationCenterStore(
    'messagesListPaginationData'
  );
  const { initialLimit } = messagesListPaginationData;
  const { f } = useI18n();
  const { pathname } = useLocation();
  const { replace } = useHistory();
  const { filterClassName } = classNames;

  const onFilterSet = useCallback(
    (newFilter) => {
      const filterData = { ...currentFilter, ...newFilter };
      const newUrl = stringifySearchParams(filterData);
      replace(`${pathname}?${newUrl}`);
      FETCH_MESSAGES_LIST_DATA({
        filter: prepareFilterForRequest(filterData, f),
        pagination: {
          limit: initialLimit,
          offset: 0
        }
      });
    },
    [currentFilter, FETCH_MESSAGES_LIST_DATA, f, initialLimit]
  );

  return (
    <Filter
      onSet={onFilterSet}
      classNames={{
        filterButtonClassName: styles.filterButton,
        filterClassName
      }}
      filterConfig={[
        {
          label: 'web.personaloffice.messages.filters.category.title',
          key: 'category',
          options: CATEGORIES_FILTER,
          defaultValue: ALL_FILTER_TYPE
        },
        {
          label: 'web.personaloffice.messages.filters.dates.title',
          key: 'dateOptionId',
          options: DATE_FILTER,
          defaultValue: '90',
          Component: ({ defaultValue, ...rest }) => (
            <DateSelect
              value={defaultValue}
              isWithDateRange={true}
              maxMinDate={{ days: 89 }}
              defaultDateRange={{
                dateOptionId: '90',
                startDate: f.getDateTime().minus({ days: 89 }).toISODate(),
                endDate: f.getDateTime().plus({ days: 1 }).toISODate()
              }}
              {...rest}
            />
          )
        },
        {
          label: 'web.personaloffice.messages.filters.status.title',
          key: 'status',
          options: STATUS_FILTER,
          defaultValue: ALL_FILTER_TYPE
        }
      ]}
    />
  );
};
